export default {
  specialtiesGroups: [
    {
      id:"0",
      name: 'Администратор на ресепшен'
    },
    {
      id:"1",
      name: 'Бригадир группы почтальонов'
    },
    {
      id:"2",
      name: 'Управление персоналом'
    },
    {
      id:"3",
      name: 'Административный персонал'
    },
    {
      id:"4",
      name: 'Верстальщик'
    },
    {
      id:"5",
      name: 'Воспитатель'
    },
    {
      id:"6",
      name: 'Генеральный директор'
    },
    {
      id:"7",
      name: 'Горничная'
    },
    {
      id:"8",
      name: 'Грузчик',
    },
    {
      id:"9",
      name: 'Гувернантка',
    },
    {
      id:"10",
      name: 'Дворник, Уборщик',
    },
    {
      id:"11",
      name: 'Домработник',
    },
    {
      id:"12",
      name: 'Домработница',
    },
    {
      id:"13",
      name: 'Консультант в сервисный центр',
    },
    {
      id:"14",
      name: 'Контент менеджер',
    },
    {
      id:"15",
      name: 'Контролер',
    },
    {
      id:"16",
      name: 'Контроллер',
    },
    {
      id:"17",
      name: 'Копирайтер',
    },
    {
      id:"18",
      name: 'Курьер',
    },
    {
      id:"19",
      name: 'Логист / Диспетчер',
    },
    {
      id:"20",
      name: 'Маляр',
    },
    {
      id:"21",
      name: 'Мастер - отделочник',
    },
    {
      id:"22",
      name: 'Мастер по мелкому бытовому ремонту',
    },
    {
      id:"23",
      name: 'Мастер по ремонту ванных комнат, кухонь, квартир',
    },
    {
      id:"24",
      name: 'Менеджер группы инженеров в отдел по крупному бытовому ремонту',
    },
    {
      id:"25",
      name: 'Менеджер группы инженеров в отдел по мелкому бытовому ремонту',
    },
    {
      id:"26",
      name: 'Менеджер группы инженеров в отдел по ремонту компьютерной техники',
    },
    {
      id:"27",
      name: 'Менеджер группы инженеров в отдел по ремонту стиральных машин',
    },
    {
      id:"28",
      name: 'Менеджер группы инженеров в отдел по ремонту холодильного оборудования',
    },
    {
      id:"29",
      name: 'Менеджер группы распространителей рекламной продукции',
    },
    {
      id:"30",
      name: 'Менеджер по персоналу / Рекрутер',
    },
    {
      id:"31",
      name: 'Менеджер по поиску и привлечению новых клиентов',
    },
    {
      id:"32",
      name: 'Менеджер по продажам рекламных услуг',
    },
    {
      id:"33",
      name: 'Менеджер по продажам IT услуг',
    },
    {
      id:"34",
      name: 'Менеджер по работе с клиентами в сервисный центр',
    },
    {
      id:"35",
      name: 'Монтажник',
    },
    {
      id:"36",
      name: 'Няня',
    },
    {
      id:"37",
      name: 'Оператор Call-центра',
    },
    {
      id:"38",
      name: 'Офис-менеджер',
    },
    {
      id:"39",
      name: 'Персональный водитель',
    },
    {
      id:"40",
      name: 'Плиточник',
    },
    {
      id:"41",
      name: 'Повар',
    },
    {
      id:"42",
      name: 'Помошник марккетолога',
    },
    {
      id:"43",
      name: 'Помощник менеджера по персоналу',
    },
    {
      id:"44",
      name: 'Помощник по хозяйству',
    },
    {
      id:"45",
      name: 'Помощник руководителя',
    },
    {
      id:"46",
      name: 'Помощник специалиста по контестной рекламе',
    },
    {
      id:"47",
      name: 'Почтальон',
    },
    {
      id:"48",
      name: 'Промоутер',
    },
    {
      id:"49",
      name: 'Разнорабочий',
    },
    {
      id:"50",
      name: 'Расклейщик',
    },
    {
      id:"51",
      name: 'Репетитор',
    },
    {
      id:"52",
      name: 'Руководитель отдела наружной рекламы',
    },
    {
      id:"53",
      name: 'Руководитель отдела продаж',
    },
    {
      id:"54",
      name: 'Руководитель сервисного центра',
    },
    {
      id:"55",
      name: 'Руководитель Call-центра',
    },
    {
      id:"56",
      name: 'Садовник',
    },
    {
      id:"57",
      name: 'Сантехник',
    },
    {
      id:"58",
      name: 'Сборщик мебели',
    },
    {
      id:"59",
      name: 'Сварщик',
    },
    {
      id:"60",
      name: 'Секретарь',
    },
    {
      id:"61",
      name: 'Сервисный инженер по (BGA) ремонту бытовой электроники',
    },
    {
      id:"62",
      name: 'Сервисный инженер по (BGA) ремонту ноутбуков',
    },
    {
      id:"63",
      name: 'Сервисный инженер по ремонту персональных компьютеров',
    },
    {
      id:"64",
      name: 'Сервисный инженер по ремонту принтеров',
    },
    {
      id:"65",
      name: 'Сервисный инженер по ремонту систем вентиляции и кондиционирования',
    },
    {
      id:"66",
      name: 'Сервисный инженер по ремонту смартфонов',
    },
    {
      id:"67",
      name: 'Сервисный инженер по ремонту стиральных машин',
    },
    {
      id:"68",
      name: 'Сервисный инженер по ремонту холодильного оборудования',
    },
    {
      id:"69",
      name: 'Сервис инженер по ремонту бытовой техники',
    },
    {
      id:"70",
      name: 'Системный администратор',
    },
    {
      id:"71",
      name: 'Слесарь',
    },
    {
      id:"72",
      name: 'Специалист по восстановлению данных',
    },
    {
      id:"73",
      name: 'Специалист по вскрытию замков, сейфов',
    },
    {
      id:"74",
      name: 'Специалист по контекстной рекламе',
    },
    {
      id:"75",
      name: 'Специалист по маркетингу в интернете',
    },
    {
      id:"76",
      name: 'Столяр',
    },
    {
      id:"77",
      name: 'Супервайзер',
    },
    {
      id:"78",
      name: 'Телемаркетолог',
    },
    {
      id:"79",
      name: 'Токарь, Фрезеровщик',
    },
    {
      id:"80",
      name: 'Тренинг менеджер по продажам сервисных услуг',
    },
    {
      id:"81",
      name: 'Управляющий',
    },
    {
      id:"82",
      name: 'Ученик по ремонт холодильников',
    },
    {
      id:"83",
      name: 'Ученик по ремонту стиральных и посудомоечных машин',
    },
    {
      id:"84",
      name: 'Учитель по ремонту бытовой техники',
    },
    {
      id:"85",
      name: 'Учитель по ремонту персональных компьютеров',
    },
    {
      id:"86",
      name: 'Штукатур',
    },
    {
      id:"87",
      name: 'Электрик',
    },
    {
      id:"88",
      name: 'Электромонтер, Кабельщик',
    },
    {
      id:"89",
      name: 'Юрист',
    },
    {
      id:"90",
      name: 'SEO специалист',
    },
    {
      id:"91",
      name: 'Web дизайнер',
    }
  ],
  sequencePage: [
    {
      name        : 'specialty',
      list        : true,
      title       : 'Специальность'
    },
    {
      name        : 'numberPhone',
      typeWrapper : 'inputText',
      typeKeyboard: 'numbers',
      namePage    : 'Введите ваш номер телефона',
      text        : '+7 *** *** ** **',
      autoNext    : true,
      regexp      : /\+7 \d\d\d \d\d\d \d\d \d\d/,
      nameSizeMobile: '20px',
      title       : 'Номер телефона'
    },
    {
      name        : 'validationPhone',
      typeWrapper : 'inputText',
      typeKeyboard: 'numbers',
      namePage    : 'Введите код из смс',
      text        : '******',
      autoNext    : true,
      regexp      : /\d\d\d\d\d\d/,
      nameSizeMobile: '20px',
      title       : 'Проверка телефона',
      alert: `
      <div style="text-align: center; width: 100%">Если не пришло СМС!</div>
      <div style="text-align: center; width: 100%">Напишите нам в чат, мы поможем!</div>
      `
    },
    {
      name        : 'firstName',
      typeWrapper : 'inputText',
      typeKeyboard: 'letters',
      namePage    : 'Введите ваше имя',
      title       : 'Имя'
    },
    {
      name        : 'secondtName',
      typeWrapper : 'inputText',
      typeKeyboard: 'letters',
      namePage    : 'Введите вашу фaмилию',
      title       : 'Фамилия'
    },
    {
      name        : 'middleName',
      typeWrapper : 'inputText',
      typeKeyboard: 'letters',
      namePage    : 'Введите ваше отчество',
      title       : 'Отчество',
      emptyNext   : true
    },
    // {
    //   name        : 'EMail',
    //   typeWrapper : 'inputText',
    //   typeKeyboard: 'lettersLat',
    //   namePage    : 'Введите ваш адрес электронной почты',
    //   emptyNext   : true,
    //   title       : 'Email',
    //   nameSizeMobile: '19px',
    //   regexp      : /^(|(([A-Za-z0-9]+_+)|([A-Za-z0-9]+\-+)|([A-Za-z0-9]+\.+)|([A-Za-z0-9]+\++))*[A-Za-z0-9]+@((\w+\-+)|(\w+\.))*\w{1,63}\.[a-zA-Z]{2,6})$/
    // },
    {
      name        : 'city',
      typeWrapper : 'inputText',
      typeKeyboard: 'letters',
      namePage    : 'Город вашего фактического проживания',
      title       : 'Город',
      alert: `
      <p>Если город заполнился серой подсказкой, Вы можете нажать далее. Вы так-же можете уточнить город(поселок) добавив область или регион.</p>
      `
    },
    {
      name        : 'street',
      typeWrapper : 'inputText',
      typeKeyboard: 'letters2',
      namePage    : 'Улица вашего фактического адреса проживания',
      title       : 'Улица',
      emptyNext   : 'true',
      alert: `
      <p><b>Ваш фактический адрес</b> обязателен для заполнения, если Вы хотите приступить к работе немедллено в противном случае Вам потребутся ожидать модерации. Вы можете пропустить это поле!</p>
      `
    },
    {
      name        : 'numberHouse',
      typeWrapper : 'inputText',
      typeKeyboard: 'numbersAndLetters',
      namePage    : 'Номер дома',
      title       : 'Номер/корпус дома',
      emptyNext   : 'true',
      alert: `
      <p><b>Ваш фактический адрес</b> обязателен для заполнения, если Вы хотите приступить к работе немедллено в противном случае Вам потребутся ожидать модерации. Вы можете пропустить это поле!</p>
      `
    },
    // {
    //   name        : 'corpusHouse',
    //   typeWrapper : 'inputText',
    //   typeKeyboard: 'numbersAndLetters',
    //   namePage    : 'Корпус',
    //   emptyNext   : true,
    //   title       : 'Корпус'
    // },
    // {
    //   name        : 'entranceHouse',
    //   typeWrapper : 'inputText',
    //   typeKeyboard: 'numbersAndLetters',
    //   namePage    : 'Подъезд',
    //   emptyNext   : true,
    //   title       : 'Подъезд'
    // },
    // {
    //   name        : 'floor',
    //   typeWrapper : 'inputText',
    //   typeKeyboard: 'numbersAndLetters',
    //   namePage    : 'Этаж',
    //   emptyNext   : true,
    //   title       : 'Этаж'
    // },
    {
      name        : 'numberApartment',
      typeWrapper : 'inputText',
      typeKeyboard: 'numbersAndLetters',
      namePage    : 'Номер квартиры',
      emptyNext   : true,
      title       : 'Квартира'
    },
    {
      name        : 'country',
      typeWrapper : 'inputText',
      typeKeyboard: 'coutry',
      autoNext    : true,
      namePage    : 'Укажите ваше гражданство',
      // emptyNext   : true,
      title       : 'Гражданство',
      alert: `
      <p><b>Гражданство</b> обязательно для заполнения, если Вы хотите приступить к работе немедллено в противном случае Вам потребутся ожидать модерации. Вы можете пропустить это поле!</p>
      `
    },
    // //депенд
    // //РФ
    {
      name        : 'numberPasport',
      typeWrapper : 'inputText',
      typeKeyboard: 'numbers',
      namePage    : 'Серия и номер паспорта РФ',
      text        : '** ** *** ***',
      startText   : '** ** *** ***',
      autoNext    : true,
      // emptyNext   : true,
      regexp      : /\d\d \d\d \d\d\d \d\d\d/,
      title       : 'Паспорт',
      depend      : 10,
      defaultEmpty: true,
      dependData  : 'РФ',
      alert: `
      <p><b>Серия и номер паспорта</b> обязательно для заполнения, если Вы хотите приступить к работе немедллено в противном случае Вам потребутся ожидать модерации. Вы можете пропустить это поле!</p>
      `
    },
    //РБ
    {
      name        : 'numberPasport',
      typeWrapper : 'inputText',
      typeKeyboard: 'NumbersAndLettersLat',
      namePage    : 'Серия и номер паспорта РБ',
      text        : '__ ** ** ***',
      startText   : '__ ** ** ***',
      autoNext    : true,
      // emptyNext   : true,
      regexp      : /[a-zA-Z][a-zA-Z] \d\d \d\d \d\d\d/,
      title       : 'Паспорт',
      depend      : 10,
      defaultEmpty: true,
      dependData  : 'РБ',
      alert: `
      <p><b>Серия и номер паспорта</b> обязательно для заполнения, если Вы хотите приступить к работе немедллено в противном случае Вам потребутся ожидать модерации. Вы можете пропустить это поле!</p>
      `
      //АА1234567
    },
    //КЗ
    {
      name        : 'numberPasport',
      typeWrapper : 'inputText',
      typeKeyboard: 'numbers',
      namePage    : 'Серия и номер паспорта КЗ',
      text        : '*** *** *** ***',
      startText   : '*** *** *** ***',
      autoNext    : true,
      // emptyNext   : true,
      regexp      : /\d\d\d \d\d\d \d\d\d \d\d\d/,
      title       : 'Паспорт',
      depend      : 10,
      defaultEmpty: true,
      dependData  : 'КЗ',
      alert: `
      <p><b>Серия и номер паспорта</b> обязательно для заполнения, если Вы хотите приступить к работе немедллено в противном случае Вам потребутся ожидать модерации. Вы можете пропустить это поле!</p>
      `
      //КЗ 123456789012
    },
    //КР
    {
      name        : 'numberPasport',
      typeWrapper : 'inputText',
      typeKeyboard: 'NumbersAndLettersLat',
      namePage    : 'Серия и номер паспорта КР',
      text        : '__ ** ** ***',
      startText   : '__ ** ** ***',
      autoNext    : true,
      // emptyNext   : true,
      regexp      : /[a-zA-Z][a-zA-Z] \d\d \d\d \d\d\d/,
      title       : 'Паспорт',
      depend      : 10,
      defaultEmpty: true,
      dependData  : 'КР',
      alert: `
      <p><b>Серия и номер паспорта</b> обязательно для заполнения, если Вы хотите приступить к работе немедллено в противном случае Вам потребутся ожидать модерации. Вы можете пропустить это поле!</p>
      `
      //AB1234567
    },
    //АР
    {
      name        : 'numberPasport',
      typeWrapper : 'inputText',
      typeKeyboard: 'NumbersAndLettersLat',
      namePage    : 'Серия и номер паспорта АР',
      text        : '__ ** ** ***',
      startText   : '__ ** ** ***',
      autoNext    : true,
      // emptyNext   : true,
      regexp      : /[a-zA-Z][a-zA-Z] \d\d \d\d \d\d\d/,
      title       : 'Паспорт',
      depend      : 10,
      defaultEmpty: true,
      dependData  : 'АР',
      alert: `
      <p><b>Серия и номер паспорта</b> обязательно для заполнения, если Вы хотите приступить к работе немедллено в противном случае Вам потребутся ожидать модерации. Вы можете пропустить это поле!</p>
      `
      //АА1234567
    },
    //РВП
    {
      name        : 'numberPasport',
      typeWrapper : 'inputText',
      typeKeyboard: 'numbers',
      namePage    : 'Серия и номер паспорта РВП',
      text        : '*** ***',
      startText   : '*** ***',
      autoNext    : true,
      // emptyNext   : true,
      regexp      : /\d\d\d \d\d\d/,
      title       : 'Паспорт',
      depend      : 10,
      defaultEmpty: true,
      dependData  : 'РВП',
      alert: `
      <p><b>Серия и номер паспорта</b> обязательно для заполнения, если Вы хотите приступить к работе немедллено в противном случае Вам потребутся ожидать модерации. Вы можете пропустить это поле!</p>
      `
    },
    //депенд
    {
      name        : 'dataGetPasport',
      typeWrapper : 'inputText',
      typeKeyboard: 'numbers',
      text        : '** ** ****',
      namePage    : 'Дата выдачи паспорта',
      title       : 'Дата выдачи паспорта',
      regexp      : /([0-2]\d|3[01])\ (0\d|1[012])\ ((19[5-9][0-9])|(2000)|(200[0-9])|(201[0-9])|(202[0-9]))/,
      autoNext    : true,
      // emptyNext   : true,
      alert: `
      <p><b>Дата выдачи паспорта</b> обязательно для заполнения, если Вы хотите приступить к работе немедллено в противном случае Вам потребутся ожидать модерации. Вы можете пропустить это поле!</p>
      `
    },
    {
      name        : 'departmentGivePasport',
      typeWrapper : 'inputText',
      typeKeyboard: 'letters',
      namePage    : 'Кем выдан паспорт',
      title       : 'Кем выдан паспорта',
      emptyNext   : true,
      alert: `
      <p><b>Орган выдавший паспорт</b> обязателен для заполнения, если Вы хотите приступить к работе немедллено в противном случае Вам потребутся ожидать модерации. Вы можете пропустить это поле!</p>
      `
    },
    {
      name        : 'registrationAddress',
      typeWrapper : 'inputText',
      typeKeyboard: 'letters2',
      namePage    : 'Адрес по прописке',
      title       : 'Адрес по прописке',
      emptyNext   : true,
      alert: `
      <p><b>Адрес по прописке</b> обязателен для заполнения, если Вы хотите приступить к работе немедллено в противном случае Вам потребутся ожидать модерации. Вы можете пропустить это поле!</p>
      `
    },
    {
      name        : 'birthtday',
      typeWrapper : 'inputText',
      typeKeyboard: 'numbers',
      namePage    : 'Дата вашего рождения',
      text        : '** ** ****',
      autoNext    : true,
      regexp      : /([0-2]\d|3[01])\ (0\d|1[012])\ ((19[5-9][0-9])|(2000)|(200[0-9])|(201[0-8]))/,
      title       : 'Дата рождения'
    },
    {
      name        : 'gender',
      typeWrapper : 'inputText',
      typeKeyboard: 'gender',
      namePage    : 'Укажите ваш пол',
      autoNext    : true,
      title       : 'Пол'
    },
    // {
    //   name        : 'car',
    //   typeWrapper : 'inputText',
    //   typeKeyboard: 'boolean',
    //   namePage    : 'Наличие автомобиля',
    //   autoNext    : true,
    //   title       : 'Автомобиль'
    // },
    // {
    //   name        : 'categoryCar',
    //   typeWrapper : 'inputText',
    //   typeKeyboard: 'categoryCar',
    //   namePage    : 'Какие категории прав на управление транспортного средства у вас имеются',
    //   nameSize    : '25px',
    //   autoNext    : true,
    //   depend      : 19,
    //   dependData  : 'ДА',
    //   title       : 'Категории прав'
    // },
    // {
    //   name        : 'lastMoney',
    //   typeWrapper : 'inputText',
    //   typeKeyboard: 'numbersMoney',
    //   namePage    : 'Ваш средний заработок в месяц за последние 6 месяцев',
    //   text        : '** 000 р.',
    //   regexp      : /\d\d?\d 000 \р\./,
    //   nameSize    : '28px',
    //   title       : 'Прошлый заработок'
    // },
    // {
    //   name        : 'futureMoney',
    //   typeWrapper : 'inputText',
    //   typeKeyboard: 'numbersMoney',
    //   namePage    : 'Ваш планируемый заработок в месяц на следующие 6 месяцев',
    //   text        : '** 000 р.',
    //   regexp      : /\d\d?\d 000 \р\./,
    //   nameSize    : '28px',
    //   title       : 'Планируемый заработок'
    // },
    // {
    //   name        : 'lastNameOfWork',
    //   typeWrapper : 'inputText',
    //   typeKeyboard: 'letters',
    //   namePage    : 'Введите наименование компании вашего последнего места работы',
    //   title       : 'Последнее песто работы'
    // },
    // {
    //   name        : 'recomendFirstName',
    //   typeWrapper : 'inputText',
    //   typeKeyboard: 'letters',
    //   namePage    : 'Укажите имя человека который вас может порекомендовать',
    //   title       : 'Имя рекомендодателя'
    // },
    // {
    //   name        : 'recomendMiddleName',
    //   typeWrapper : 'inputText',
    //   typeKeyboard: 'letters',
    //   namePage    : 'Укажите отчество человека который вас может порекомендовать',
    //   emptyNext   : true,
    //   nameSize    : '20px',
    //   title       : 'Отчество рекомендодателя'
    // },
    // {
    //   name        : 'recomendNumberPhone',
    //   typeWrapper : 'inputText',
    //   typeKeyboard: 'numbers',
    //   namePage    : 'Введите номер телефона  человека который может вас порекомендовать',
    //   nameSize    : '27px',
    //   text        : '+7 *** *** ** **',
    //   autoNext    : true,
    //   regexp      : /\+7 \d\d\d \d\d\d \d\d \d\d/,
    //   title       : 'Телефон рекомендодателя'
    // },
    {
      name        : 'infoAbout',
      typeWrapper : 'inputText',
      typeKeyboard: 'infoAbout',
      autoNext    : true,
      namePage    : 'Выберите из какого источника узнали о нашей компании',
      title       : 'Информация о нас'
    },
    {
      name        : 'photo',
      typeWrapper : 'inputPhoto',
      namePage    : 'Фото лица для анкеты',
      regexp      : /.*/,
      autoNext    : true,
      title       : 'Фото',
      // emptyNext   : true
      alert: `
      <p>Для анкеты нам требуется Ваша фотография.</p>
      `
    },
    {
      name        : 'photo2',
      typeWrapper : 'inputPhoto',
      namePage    : 'Фото паспорта для анкеты',
      regexp      : /.*/,
      autoNext    : true,
      title       : 'Фото',
      alert: `
      <p>Загрузите фото паспорта, где отображено: кем выдан, фотография, серия и паспорт.</p>
      <img src="/img/passport.png" />
      <p style="font-size: 16px;margin-top: 10px;">Не беспокойтесь ваши персональные данные никуда не передаются.</p>
      `
    },
    {
      name        : 'photo3',
      typeWrapper : 'inputPhoto',
      namePage    : 'Фото лица и паспорта (селфи)',
      regexp      : /.*/,
      autoNext    : true,
      title       : 'Фото',
      alert: `
      <p>Постарайтесь найти освещенное место - например встаньте лицом к окну и держите раскрытый паспорт рядом с лицом.</p>
      <img src="/img/selfePassport.png" />
      <p style="font-size: 16px;margin-top: 10px;">Это обычное требование для того чтобы удостоверится, что вы самостоятельно регистрируетесь и ваши документы у вас.</p>
      `
    },
    {
      name: 'categoriesTest',
      typeWrapper : 'inputTests',
      typeKeyboard: 'test',
      title       : 'Тестирование'
    }
  ]
}



/** WEBPACK FOOTER **
 ** ./assets/config/index.js
 **/